// This function allow to reference chunks
__webpack_require__.u = function(chunkId) {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "js/" + "actioncable" + "-" + "a52be18d95d1fc62" + ".chunk.js"
}